import { LucideIcon } from "lucide-react";
import { IconType } from "react-icons";
import { IconWrapper } from "./iconWrapper";
import { GroupsEnum } from "@/enum/groups";
import { RoleEnum } from "@/enum/role";
import type { RouteTab } from "@/@types/tab-navigation";

type RouteConfig = {
  id: string;
  category: string;
  requiredRole: RoleEnum[];
  groupRequired: GroupsEnum[];
  requiredAction?: string[];
  path: string;
  pathId: string;
  element: JSX.Element;
  Icon: LucideIcon | IconType;
  iconClassName?: string;
  overrideIconColor?: boolean;
  tabs?: RouteTab[];
  hiddenInSidebarOf?: GroupsEnum[];
};

export function createRoute({
  id,
  category,
  requiredRole,
  groupRequired,
  requiredAction = [],
  path,
  pathId,
  element,
  Icon,
  iconClassName = "",
  overrideIconColor = false,
  tabs = [],
  hiddenInSidebarOf = [],
}: RouteConfig) {
  return {
    id,
    category,
    requiredRole,
    groupRequired,
    requiredAction,
    path,
    pathId,
    element,
    icon: <IconWrapper Icon={Icon} className={iconClassName} overrideColor={overrideIconColor} />,
    tabs,
    hiddenInSidebarOf,
  };
}
